"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneExtension = void 0;
const react_1 = __importDefault(require("react"));
const text_input_1 = __importDefault(require("../text-input"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const styles_1 = require("../../../styles");
const PhoneExtension = ({ path }) => {
    const [state] = (0, use_form_1.default)(path);
    const { config: { isVisible = false } = {} } = state;
    if (isVisible === false)
        return null;
    return (react_1.default.createElement(styles_1.FieldStyles, { flexGrow: 2 },
        react_1.default.createElement(text_input_1.default, { path: path, "data-testid": path })));
};
exports.PhoneExtension = PhoneExtension;
//# sourceMappingURL=phone-entension.js.map